import { getCookie } from "./utils";


export function checkToken() {
	var token = getCookie('mtoken')
	if (!token) { 
		return false
	}
	// const res = await fetch(`https://sso-panbadou-test.panzitech.com/auth/verifyToken?token=${token}&platform=MATERIAL`, {
	// 	method: "GET"
	// }).then(res => res.json())

	// if (res.result.isValid) {
	// 	return true;
	// }
	return true;
}